// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "chunks/" + chunkId + "." + {"vendors-node_modules_swiper_shared_utils_mjs":"f6f5ecead5a22d89b200","vendors-node_modules_swiper_swiper_mjs":"cfa5d005f98f87166694","vendors-node_modules_swiper_modules_index_mjs":"2b300710aaf2e579555a"}[chunkId] + ".js";
};